import { useState, useContext } from "react";

import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import BotonAccion from "../../../componentsUI/formularios/button/BotonAction.js";
import CategoriasSeleccion from "../categorias/categoriasSeleccion.js";

import { ahora } from "../../../../utils/fechas.js";
import { formatearPrecio } from "../../../../utils/precios.js";

import "./form.css";

import { GastosContext } from "../../../contexto/provider/GastosContext.js";

export default function FormularioGasto() {

  const { registrarGasto } = useContext(GastosContext);

  const estadoInicial = {
    valorItem: "",
    cantidad: "1",
    observaciones: "",
    itemSeleccionado: null,
    formaPago: "Efectivo",
    proveedor: ""
  };

  const [form, setForm] = useState(estadoInicial);

  const handleChange = (campo, valor) => {
    setForm((prev) => ({
      ...prev,
      [campo]: valor
    }));
  };

  const limpiarFormulario = () => {
    setForm(estadoInicial);
  };

  const total =
    (Number(form.valorItem) || 0) *
    (Number(form.cantidad) || 1);

  // Datos fijos
  const id_punto = 101;
  const hoy = ahora().split("T")[0];

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      id_usuario: 3,
      id_punto,

      item_valor: Number(form.valorItem),
      item_cantidad: Number(form.cantidad),

      metodo_pago: form.formaPago,
      id_categoria: form.itemSeleccionado,

      proveedor: form.proveedor,
      detalle: form.observaciones
    };

    try {
      await registrarGasto(payload);
      limpiarFormulario();
    } catch (e) {
      console.error("Error al registrar gasto:", e.message);
    }
  };

  return (
    <div>
      <TituloModulo titulo="Registro de Gasto" />

      <div className="form-containere">
        <form onSubmit={handleSubmit} className="grid-caja">

          {/* Fila 1 */}
          <div className="campo-caja">
            <label>Punto</label>
            <div className="valor">{id_punto}</div>
          </div>

          <div className="campo-caja">
            <label>Fecha</label>
            <div className="valor">{hoy}</div>
          </div>

          {/* Fila 2 */}
          <div className="campo-caja">
            <label>Item</label>

            <CategoriasSeleccion
              value={form.itemSeleccionado}
              onChange={(v) => handleChange("itemSeleccionado", v)}
            />

          </div>

          <div className="campo-caja">
            <label>Valor</label>

            <input
              type="text"
              inputMode="numeric"
              placeholder="0"
              value={form.valorItem ? formatearPrecio(form.valorItem) : ""}
              onChange={(e) =>
                handleChange(
                  "valorItem",
                  e.target.value.replace(/\D/g, "")
                )
              }
            />
          </div>

          <div className="campo-caja">
            <label>Cantidad</label>

            <input
              type="number"
              min="1"
              value={form.cantidad}
              onChange={(e) =>
                handleChange(
                  "cantidad",
                  e.target.value.replace(/\D/g, "")
                )
              }
            />
          </div>

          <div className="campo-caja total-caja">
            <label>Total</label>
            <div className="valor total">
              {formatearPrecio(total)}
            </div>
          </div>

          <div className="campo-caja">
            <label>Forma de Pago</label>

            <select
              className="selection"
              value={form.formaPago}
              onChange={(e) =>
                handleChange("formaPago", e.target.value)
              }
            >
              <option value="Efectivo">Efectivo</option>
              <option value="Daviplata">Daviplata</option>
              <option value="Nequi">Nequi</option>
              <option value="Breb">Breb</option>
            </select>
          </div>

          {/* Fila 3 */}
          <div className="campo-caja">
            <label>Observaciones</label>

            <input
              type="text"
              value={form.observaciones}
              onChange={(e) =>
                handleChange("observaciones", e.target.value)
              }
              placeholder="Añada detalles del gasto"
              maxLength={30}
            />
          </div>

          <div className="campo-caja">
            <label>Proveedor</label>

            <input
              type="text"
              value={form.proveedor}
              onChange={(e) =>
                handleChange("proveedor", e.target.value)
              }
              placeholder="Nombre del proveedor"
              maxLength={30}
            />
          </div>

          <div className="campo-caja">
            <label>Usuario</label>
            <div className="valor">Admin</div>
          </div>

          {/* Acción */}
          <div className="campo-caja campo-accion">
            <BotonAccion type="submit">
              Crear Gasto
            </BotonAccion>
          </div>

        </form>
      </div>
    </div>
  );
}